
import { mixins, Options } from 'vue-class-component';
import { Redemption, ShopifySubmission } from '@/api/models';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import WithCampaignConstants from '@/mixins/WithCampaignConstants';
import LazyImage from '../LazyImage.vue';
import MToken from '../MToken.vue';
import MRedemptionButtonSection from './MRedemptionButtonSection.vue';

@Options({
  components: {
    LazyImage,
    MToken,
    MRedemptionButtonSection
  }
})
export default class MRedemptionDetails extends mixins(WithCampaignConstants, CampaignWidgetMixin) {
  // component methods
  get redemptionToToken(): Redemption {
    const currentRedemption: any = this.state.activeRedemption!;
    const product = this.state.shopifyProducts!.find((product: any) => {
      return (
        product.productId == (currentRedemption!.submissions![0] as ShopifySubmission).productId!
      );
    });
    currentRedemption['product'] = product;
    return currentRedemption;
  }

  get currentSubmission(): ShopifySubmission {
    return this.redemptionToToken.submissions![0] as ShopifySubmission;
  }

  get productImageSource(): string {
    return this.redemptionToToken?.product?.productData?.image?.src || '';
  }

  // product helpers
  productIdToName(productId: string) {
    const allProducts = this.state.shopifyProducts;
    const selectedProduct = allProducts!.find((product: any) => product.productId == productId);
    return selectedProduct!.productData.title;
  }

  // Get title of variant from the variant ID. Not super efficient, maybe better splitting into the store
  // somewhere and making globally available.
  variantIdToString(variantId: string) {
    const productId = (this.state.activeRedemption.submissions![0] as ShopifySubmission).productId;
    const allProducts = this.state.shopifyProducts;
    const selectedProduct = allProducts!.find((product: any) => product.productId == productId);
    const selectedVariant = selectedProduct!.productData.variants.find(
      (variant: any) => `${variant.id}` == variantId
    );
    return selectedVariant.title;
  }
}
